import React,{useState} from 'react';

import {
  Zap,
  Globe,
  Cloud,
  Key,
  IdCard,
  Video,
  Database,
  Landmark,
  Shield,
  Wallet,
  UserCheck,
  ShieldAlert,
  Smartphone,
  HelpCircle  
} from 'lucide-react';
 

const features = [
  { icon: <IdCard size={24} color="#fff" />, title: "AMLA AADHAR", desc: "PAN & AADHAR Verification", bg: "#3b82f6" },
  { icon: <Video size={24} color="#fff" />, title: "Video KYC", desc: "RBI Compliant", bg: "#8b5cf6" },
  { icon: <Database size={24} color="#fff" />, title: "Central KYC", desc: "Unified Database", bg: "#6366f1" },
  { icon: <Landmark size={24} color="#fff" />, title: "Co-operative Bank", desc: "Payment Solutions", bg: "#10b981" },
  { icon: <Shield size={24} color="#fff" />, title: "Data Vault", desc: "Secure Storage", bg: "#ef4444" },
  { icon: <Wallet size={24} color="#fff" />, title: "India Loan", desc: "Lending Platform", bg: "#f59e0b" },
  { icon: <UserCheck size={24} color="#fff" />, title: "Digital Onboarding", desc: "Customer Journey", bg: "#14b8a6" },
  { icon: <ShieldAlert size={24} color="#fff" />, title: "FEMA Risk Management", desc: "Fraud Prevention", bg: "#fb923c" },
  { icon: <Smartphone size={24} color="#fff" />, title: "TAB Banking", desc: "Mobile Solutions", bg: "#06b6d4" },
  { icon: <HelpCircle size={24} color="#fff" />, title: "Grievance System", desc: "Customer Care", bg: "#ec4899" },
];

const stats = [
  { icon: <Globe size={28} color="#3b82f6" />, label: "Financial Services", value: "10+" },
  { icon: <Zap size={28} color="#f59e0b" />, label: "Uptime Guarantee", value: "99.9%" },
  { icon: <Key size={28} color="#10b981" />, label: "Encryption", value: "256-bit" },
  { icon: <Cloud size={28} color="#8b5cf6" />, label: "Support", value: "24/7" },
];

const FeatureCard = ({ item }) => (
  <div style={{
    background: 'white',
    padding: '1.5rem 1rem',
    borderRadius: '1rem',
    boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
    textAlign: 'center',
    transition: 'all 0.3s ease'
  }}>
    <div style={{
      width: '48px',
      height: '48px',
      borderRadius: '12px',
      backgroundColor: item.bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 1rem',
      marginBottom:"1rem"
    }}>
      {item.icon}
    </div>
    <h4 style={{ fontSize: '16px', fontWeight: '700', color: '#1e293b', marginBottom: '0.3rem' }}>{item.title}</h4>
    <p style={{ fontSize: '16px', color: '#64748b' }}>{item.desc}</p>
  </div>
);
 const topCards = [
    { title: 'Bank / PPI', color: '#059669', letter: 'B' },
    { title: 'Bill Pay', color: '#3b82f6', letter: 'B' },
    { title: 'Payment Aggregator & Payment Gateway', color: '#10b981', letter: 'P' },
    { title: 'Digital Bank', color: '#f59e0b', letter: 'D' },
    { title: 'Govt. Inst. & Regulators', color: '#8b5cf6', letter: 'G' },
    { title: 'Sanction Lists & Transaction Monitoring', color: '#ef4444', letter: 'S' },
  ];

  const bottomCards = [
    { title: 'Virtual Accounts', color: '#10b981', letter: 'V' },
    { title: 'Payments', color: '#3b82f6', letter: 'P' },
    { title: 'Cards', color: '#06b6d4', letter: 'C' },
    { title: 'Lending', color: '#f59e0b', letter: 'L' },
    { title: 'KYC', color: '#8b5cf6', letter: 'K' },
    { title: 'AML', color: '#ef4444', letter: 'A' },
  ];


const BaasCard = ({ title, color, letter }) => (
  <div style={{
    background: '#ffffff',
    padding: '1.2rem',
    borderRadius: '1rem',
    width: '160px',
    textAlign: 'center',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.08)',
    transition: '0.3s',
  }}>
    <div style={{
      width: '48px',
      height: '48px',
      margin: '0 auto 0.5rem',
      borderRadius: '9999px',
      backgroundColor: color,
      color: 'white',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.1rem'
    }}>{letter}</div>
    <p style={{ fontSize: '0.9rem', fontWeight: '500', color: '#1e293b' }}>{title}</p>
  </div>
);

 const HoverableInfoCard = ({ tag, tagColor, title, description }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: 'relative',
        backgroundColor: '#ffffff',
        borderRadius: '1rem',
        padding: '2rem',
        boxShadow: '0 10px 15px rgba(0, 0, 0, 0.05)',
        textAlign: 'left',
        transition: 'transform 0.3s ease',
        cursor: 'pointer',
      }}
    >
      {/* Top-right circle */}
      <div
        style={{
          position: 'absolute',
          top: '1rem',
          right: '1rem',
          width: '1rem',
          height: '1rem',
          borderRadius: '50%',
          backgroundColor: hovered ? '#efa844ff' : '#e2e8f0',
          transition: 'background-color 0.3s ease',
        }}
      ></div>

      <span
        style={{
          backgroundColor: tagColor,
          color: '#ffffff',
          fontSize: '16px',
          fontWeight: '600',
          padding: '0.25rem 0.75rem',
          borderRadius: '9999px',
          display: 'inline-block',
          marginBottom: '1rem',
        }}
      >
        {tag}
      </span>

      <h4
        style={{
          fontSize: '16px',
          fontWeight: 600,
          color: '#4b4b4cff',
          marginBottom: '1rem',
        }}
      >
        {title}
      </h4>

      <p
        style={{
          fontSize: '16px',
          color: '#475569',
        }}
      >
        {description}
      </p>
    </div>
  );
};
export default function TAApiBankingPlatform() {
  return (
    <div className="financial-launch">
   <style>
{`
  @keyframes slideInLeft {
    from {
      transform: translateX(-50px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
   @keyframes zoomIn {
            0% {
              transform: scale(0.8);
              opacity: 0;
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }

  .slide-left {
    animation: slideInLeft 1s ease forwards;
  }
.zoom-in {
            animation: zoomIn 1s ease-out forwards;
          }

  @media (max-width: 768px) {
    .launch-container section {
      flex-direction: column;
      padding: 1rem !important;
    }

    .launch-left-content {
      padding-left: 0 !important;
      text-align: center;
    }

    .launch-stats {
      justify-content: center;
      gap: 2rem !important;
    }

    .launch-right-card {
      margin-top: 2rem;
    }

    .launch-right-card-inner {
      width: 100% !important;
      max-width: 350px;
    }

    .launch-left-content h1,
    .launch-left-content p {
      text-align: left !important;
    }

    .launch-stats {
      justify-content: flex-start !important;
    }
  }
`}
</style>

<div
  className="launch-container"
  style={{
    background: 'linear-gradient(140deg, #fdfee7ff, #ecfdf5)',
    paddingTop: '40px',
    paddingBottom: '50px',
  }}
>
  <section
    className="container"
    style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '2rem',
    }}
  >
    {/* Left Content */}
    <div
      className="launch-left-content slide-left"
      style={{
        flex: '1',
        minWidth: '320px',
        maxWidth: '650px',
        paddingLeft: '2rem',
        paddingRight: '2rem',
      }}
    >
      <div className="launch-text">
        <h1
          style={{
            fontSize: '40px',
            fontWeight: '800',
            lineHeight: '1.2',
            marginTop: '20px',
            color: '#0f172a',
          }}
        >
          Launch Financial
        </h1>
        <h1
          style={{
            fontSize: '40px',
            fontWeight: '800',
            lineHeight: '1.2',
            color: 'black',
          }}
        >
          Innovation Faster
        </h1>

        <p
          style={{
            fontSize: '18px',
            color: '#475569',
            marginTop: '1rem',
            maxWidth: '600px',
          }}
        >
          Your Launchpad for Financial Innovation. Transform your business
          with our comprehensive API banking platform designed for modern
          financial services.
        </p>

        {/* Stats */}
        <div
          className="launch-stats"
          style={{
            display: 'flex',
            gap: '5rem',
            marginTop: '3rem',
            textAlign: 'center',
            flexWrap: 'wrap',
          }}
        >
          <div>
            <strong style={{ color: '#059669', fontSize: '2rem' }}>
              99.9%
            </strong>
            <br />
            <span style={{ color: '#475569' }}>Uptime</span>
          </div>
          <div>
            <strong style={{ color: '#6366f1', fontSize: '2rem' }}>
              500+
            </strong>
            <br />
            <span style={{ color: '#475569' }}>API Endpoints</span>
          </div>
          <div>
            <strong style={{ color: '#059669', fontSize: '2rem' }}>
              24/7
            </strong>
            <br />
            <span style={{ color: '#475569' }}>Support</span>
          </div>
        </div>
      </div>
    </div>

    {/* Right Image */}
    <div
      className="launch-right-image zoom-in"
      style={{
        flex: '1',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '320px',
        paddingRight: '2rem',
      }}
    >
      <img
        src="/assets/images/apiimg.png"
        alt="Financial Innovation"
        style={{
          maxWidth: '80%',
          height: 'auto',
          borderRadius: '1rem',
          marginLeft: '100px',
        }}
      />
    </div>
  </section>
</div>

<section
  className="info-section"
  style={{
    padding: '4rem 2rem',
    backgroundColor: '#f8fafc',
    textAlign: 'center',
  }}
>
  <div className="container">
    <h2
      style={{
        fontSize: '40px',
        fontWeight: 700,
        color: '#0f172a',
        marginBottom: '1rem',
      }}
    >
      Enabling Financial Disruption
    </h2>
    <p
      style={{
        fontSize: '18px',
        color: '#64748b',
        marginBottom: '2.5rem',
        maxWidth: '540px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      Discover how our platform empowers different industries to innovate and
      transform their financial services.
    </p>

    <div
      className="info-grid"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '2rem',
        justifyItems: 'center',
        padding: '50px 0px',
      }}
    >
      <HoverableInfoCard
        tag="Digital Bank"
        tagColor="#3b82f6"
        title="Are you transforming to become a Digital Bank?"
        description="Leverage our modular API stack to power your digital platform."
      />
      <HoverableInfoCard
        tag="Embedded Finance Solutions"
        tagColor="#10b981"
        title="Are you launching Embedded Finance Solutions?"
        description="Embed new layers & financial products into your services and enter new BFSI-type payment services in the market."
      />
      <HoverableInfoCard
        tag="Healthcare Provider"
        tagColor="#f59e0b"
        title="Are you a Health Care Provider?"
        description="Enable instant payouts, finance flows, and compliance tools."
      />
      <HoverableInfoCard
        tag="Neobank"
        tagColor="#8b5cf6"
        title="Are you Edtech?"
        description="Build & launch your differentiated products or scale your existing platforms with our virtual core."
      />
      <HoverableInfoCard
        tag="E-commerce"
        tagColor="#ef4444"
        title="Are you an E-commerce Payments Provider?"
        description="Integrate seamless checkout, payments, and refunds."
      />
      <HoverableInfoCard
        tag="Insurance"
        tagColor="#06b6d4"
        title="Are you an Insurtech Company?"
        description="Automate claims, premium collection, and policy disbursals."
      />
    </div>
  </div>
</section>

<>
  {/* Responsive Styles */}
  <style>
    {`
      @media (max-width: 768px) {
        .finance-section {
          padding: 2rem 1rem !important;
        }

        .finance-section h2 {
          font-size: 1.6rem !important;
        }

        .finance-section p {
          font-size: 1rem !important;
        }

        .finance-circle {
          width: 120px !important;
          height: 120px !important;
          font-size: 0.8rem !important;
        }

        .finance-circle span {
          font-size: 0.9rem !important;
        }

        .finance-grid {
          grid-template-columns: 1fr !important;
          padding: 0 !important;
        }

        .finance-stats {
          grid-template-columns: 1fr !important;
          gap: 1rem !important;
        }
      }
         @media (max-width: 480px) {
        .finance-section h2 {
          font-size: 1.8rem;
        }

        .finance-section p {
          font-size: 1rem;
        }

        .center-circle {
          width: 120px;
          height: 120px;
          font-size: 0.8rem;
        }
      }
  `}
     
  </style>
<section
  className="finance-section"
  style={{
    padding: '4rem 1rem',
    background: 'linear-gradient(to bottom right, #f4fdf8, #f1f5f9)',
    textAlign: 'center',
  }}
>
  <div
    className="container"
    style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 1rem',
    }}
  >
    <h2 style={{ fontSize: '40px', fontWeight: '700' }}>
      Revolutionizing{' '}
      <span style={{ color: '#3e7235ff', fontSize: '2.3rem' }}>
        Access to Finance
      </span>
    </h2>

    <p
      style={{
        maxWidth: '1000px',
        margin: '1rem auto 3rem',
        fontSize: '18px',
        color: '#6b7280',
        lineHeight: '1.6',
      }}
    >
      Our platform is built on the innovative{' '}
      <a
        href="#"
        style={{ color: '#3b82f6', textDecoration: 'underline' }}
      >
        India Stack
      </a>{' '}
      to ensure a robust digital infrastructure that is secure, resilient, and
      scalable. We have architected the platform to enable innovation & choice
      for customers.
    </p>

    {/* Center Circle */}
    <div
      className="finance-circle"
      style={{
        width: '160px',
        height: '160px',
        margin: '0 auto 2.5rem',
        background: 'linear-gradient(145deg, #2a7861ff, #577dfaff)',
        color: 'white',
        borderRadius: '50%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: '600',
        fontSize: '0.95rem',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
        lineHeight: '1.2',
      }}
    >
      <span
        style={{
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '50%',
          color: '#18552cff',
          fontSize: '20px',
        }}
      >
        TA
        <br />
      </span>
      <span style={{ fontSize: '1rem', fontWeight: 'bold' }}>
        Transaction Analysts
      </span>
      <br />
      Secure Core
    </div>

    {/* Feature Cards Grid */}
    <div
      className="finance-grid"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '1.5rem',
        marginTop: '2rem',
      }}
    >
      {features.map((item, index) => (
        <FeatureCard key={index} item={item} />
      ))}
    </div>

    {/* Stats Grid */}
    <div
      className="finance-stats"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: '1.5rem',
        marginTop: '3rem',
      }}
    >
      {stats.map((stat, index) => (
        <div
          key={index}
          style={{
            background: 'white',
            padding: '1.5rem 1rem',
            borderRadius: '1rem',
            boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
            transition: '0.3s',
            textAlign: 'center',
          }}
        >
          <div style={{ marginBottom: '0.5rem' }}>{stat.icon}</div>
          <strong style={{ fontSize: '28px', color: '#111827' }}>
            {stat.value}
          </strong>
          <p style={{ fontSize: '18px', color: '#6b7280' }}>
            {stat.label}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>
</>
<section
  className="baas-section"
  style={{
    textAlign: 'center',
    padding: '4rem 1rem',
    backgroundColor: '#f6f5ff',
  }}
>
  <div
    className="container"
    style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 1rem',
    }}
  >
    <h2
      style={{
        fontSize: '2.2rem',
        fontWeight: '700',
        marginBottom: '1rem',
      }}
    >
      Banking as a Service
    </h2>

    <p
      style={{
        maxWidth: '800px',
        margin: '0 auto 2rem',
        color: '#6b7280',
        fontSize: '1rem',
        lineHeight: '1.6',
      }}
    >
      Banking as a Service (BaaS) is reconfiguring the banking value chain and
      enabling new innovative services to be rapidly taken to the marketplace.
      Banks are embedding fintech products into the customer journey instead of
      just making companies introduce banking products into their services.
    </p>

    {/* Top Row Cards */}
    <div className="baas-cards">
      {topCards.map((card, index) => (
        <BaasCard key={index} {...card} />
      ))}
    </div>

    {/* Arrows Row */}
    <div className="arrow-row">
      {Array.from({ length: 5 }).map((_, index) => (
        <div className="arrow" key={index}>
          ↓
        </div>
      ))}
    </div>

    {/* Middle Platform Card */}
    <div className="baas-banner green-blue">
      <h3>TA – BAAS – Platform</h3>
      <p>Comprehensive Banking Infrastructure</p>
    </div>

    {/* Arrows Row */}
    <div className="arrow-row">
      {Array.from({ length: 5 }).map((_, index) => (
        <div className="arrow" key={index}>
          ↓
        </div>
      ))}
    </div>

    {/* Bottom Row Cards */}
    <div className="baas-cards">
      {bottomCards.map((card, index) => (
        <BaasCard key={index} {...card} />
      ))}
    </div>

    {/* Final Footer Banner */}
    <div className="baas-banner blue-green">
      <h3>Digital Services to any Company</h3>
      <p>Scalable Solutions for Every Business</p>
    </div>
  </div>

  {/* Keyframes for bounce animation */}
  <style>
    {`
      @keyframes bounceDown {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(8px); }
      }

      .baas-cards {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 1.5rem;
        margin-bottom: 2rem;
      }

      .arrow-row {
        display: flex;
        justify-content: center;
        gap: 1.5rem;
        margin-bottom: 1.5rem;
        animation: bounceDown 1.5s infinite;
      }

      .arrow {
        font-size: 2rem;
        color: #9ca3af;
      }

      .baas-banner {
        border-radius: 1rem;
        padding: 1.5rem;
        margin: 2rem auto;
        max-width: 1100px;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
        color: white;
      }

      .green-blue {
        background: linear-gradient(to right, #059669, #0ea5e9);
      }

      .blue-green {
        background: linear-gradient(to right, #1a5747ff, #3b82f6);
        margin-top: 2rem;
      }

      .baas-banner h3 {
        font-size: 1.4rem;
        margin-bottom: 0.25rem;
      }

      .baas-banner p {
        font-size: 1rem;
      }

      @media (max-width: 768px) {
        .arrow {
          font-size: 1.5rem;
        }

        .baas-banner h3 {
          font-size: 1.2rem;
        }

        .baas-banner p {
          font-size: 0.95rem;
        }

        .baas-cards {
          flex-direction: column;
          align-items: center;
        }
      }

      @media (min-width: 1440px) {
        .baas-section h2 {
          font-size: 2.5rem;
        }

        .baas-banner h3 {
          font-size: 1.6rem;
        }

        .baas-banner p {
          font-size: 1.05rem;
        }
      }
    `}
  </style>
</section>

  <section
      style={{
        textAlign: 'center',
        padding: '4rem 1rem',
        background: '#f9fafb',
        fontFamily: 'sans-serif',
      }}
    >
      <h2
        style={{
          fontSize: '1.9rem',
          marginBottom: '0.5rem',
          fontWeight: '700',
          color: '#111827',
        }}
      >
        Accelerate Time-to-Market with our <strong>Sandbox</strong>
      </h2>

      <p
        style={{
          maxWidth: '700px',
          margin: '0 auto 2rem auto',
          color: '#4b5563',
          fontSize: '1rem',
          lineHeight: '1.6',
        }}
      >
        We have set up a dedicated testing environment to help you test drive your
        next-phase solutions prior to launch in the marketplace. Test your
        applications and simulate your regulatory tasks in a practical manner.
      </p>

      {/* Card */}
      <div
        style={{
          maxWidth: '940px',
          margin: '0 auto',
          background: 'white',
          borderRadius: '16px',
          padding: '2rem',
          boxShadow: '0 6px 24px rgba(0, 0, 0, 0.08)',
          border: '5px solid #4faea2ff',
        }}
      >
        {/* Circle */}
        <div
          style={{
            width: '70px',
            height: '70px',
            borderRadius: '50%',
            margin: '0 auto 1rem auto',
            background: 'radial-gradient(circle at center, #1e3a8a 40%, #60a5fa 100%)',
            
          }}
        />

        {/* Title */}
       <h3
  style={{
    fontSize: '1.8rem',
    fontWeight: '600',
    marginBottom: '2rem',
    background: 'linear-gradient(to right, #1a5747ff, #3b82f6)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  }}
>
  Developer Sandbox Environment
</h3>


        {/* Description */}
        <p
          style={{
            fontSize: '1.2rem',
            color: '#4b5563',
            marginBottom: '1.5rem',
            lineHeight: '1.5',
          }}
        >
          We offer a variety of support tools to accelerate your go-to-market timeline
          including API documentation, developer guides and release notes. You can even
          take our APIs for a spin. And because the time-to-value for your solution.
        </p>

        {/* Stats */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '1rem',
            textAlign: 'center',
            marginBottom: '1.5rem',
            flexWrap: 'wrap',
          }}
        >
          {/* Stat 1 */}
           <div
            style={{
              flex: '1 1 30%',
              background: '#f3f4f6',
              borderRadius: '12px',
              padding: '1.5rem',
            }}
          >
            <strong
              style={{
                fontSize: '1.9rem',
                color: '#10b981',
                fontWeight: '700',
                display: 'block',
                marginBottom: '0.25rem',
              }}
            >
             24/7
            </strong>
            <p style={{ fontSize: '0.85rem', color: '#4b5563', margin: 0 }}>
             Sandbox Access<br />
              Always Available
            </p>
          </div>


          {/* Stat 2 */}
          <div
            style={{
              flex: '1 1 30%',
              background: '#f3f4f6',
              borderRadius: '12px',
              padding: '1.5rem',
            }}
          >
            <strong
              style={{
                fontSize: '1.9rem',
                color: '#10b981',
                fontWeight: '700',
                display: 'block',
                marginBottom: '0.25rem',
              }}
            >
              100+
            </strong>
            <p style={{ fontSize: '0.85rem', color: '#4b5563', margin: 0 }}>
              API Endpoints<br />
              Full Documentation
            </p>
          </div>

          {/* Stat 3 */}
          <div
            style={{
              flex: '1 1 30%',
              background: '#f3f4f6',
              borderRadius: '12px',
              padding: '1.5rem',
            }}
          >
            <strong
              style={{
                fontSize: '1.9rem',
                color: '#10b981',
                fontWeight: '700',
                display: 'block',
                marginBottom: '0.25rem',
              }}
            >
              15min
            </strong>
            <p style={{ fontSize: '0.85rem', color: '#4b5563', margin: 0 }}>
              Quick Setup<br />
              Instant Access
            </p>
          </div>
        </div>

       {/* Button */}
<button
  style={{
    background: 'linear-gradient(to right, #1a5747ff, #3b82f6)',
    color: 'white',
    border: 'none',
    padding: '0.6rem 1.5rem',
    borderRadius: '8px',
    fontWeight: 700,
    marginTop:"20px",
    cursor: 'pointer',
    fontSize: '1.2rem',
  }}
>
  Access Sandbox Now
</button>

      </div>

      {/* Footer CTA */}
      <div style={{ marginTop: '2.5rem' }}>
        <p
          style={{
            fontWeight: 600,
            fontSize: '1.5rem',
            marginBottom: '0.25rem',
            color: '#111827',
          }}
        >
          Looking to Accelerate Your Digital Transformation?
        </p>
        <span
          style={{
            display: 'block',
            marginBottom: '1rem',
            color: '#6b7280',
            padding:"10px",
            fontSize: '1.1rem',
          }}
        >
          Flip the Switch with TA API Banking Platform
        </span>
        <button
          style={{
            padding: '0.5rem 1.2rem',
            borderRadius: '8px',
            border: '2px solid #1e8a78ff',
            backgroundColor: 'transparent',
            color: '#1e8a78ff',
            cursor: 'pointer',
            fontSize: '1.3rem',
          }}
        >
          Schedule Demo Now
        </button>
      </div>
    </section>
 
    </div>
  );
}
 
 